export default {
  title: 'Criar chave de API',
  reveal_warning: 'Guarde esta chave agora — não voltará a ser apresentada.',
  form: {
    name: 'Nome',
    name_placeholder: 'ex.: Chave de produção',
  },
  buttons: {
    cancel: 'Cancelar',
    create: 'Criar',
    done: 'Concluído',
  },
  toasts: {
    error: 'Não foi possível criar a chave. Tente novamente.',
  },
};
